import React from 'react';
import Par from "./Particles.jsx";
function background() {
    return (
        <div>
            <Par />
        </div>
    );
}

export default background;
